import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProfileSettingsIndex } from '@/pages/settings/ProfileSettingsIndex';

// `?tab=security` is how anything outside this page links straight at Connected accounts and the
// password card - the set-password prompt after create-company, and the discovery prompt.
// Loose, not strict: `?lang=en` is read off the matched route's search by `useLanguageHandler`, so
// stripping unknown keys here would quietly disable the language override on this page.
const profileSettingsSearchSchema = z.looseObject({
	tab: z.enum(['profile', 'security']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/settings/profile')({
	validateSearch: profileSettingsSearchSchema,
	component: ProfileSettingsIndex,
});
